/*
================================================================ 
         Copyright (c) 2018-2020 Digitize Things Inc.           
                     All rights reserved.                       
================================================================ 
*/

import { connect } from "react-redux";
import React, { Component } from "react";
import Grid from "@mui/material/Grid";

//add table
import ProviderTable from "./providerTable";

// API helper and constant
import BusApiCall from "../../../helper/axios.js";
import constants from "../../../helper/constants";
import actionTypes from "../../../store/actions";

// Loader
import Loader from "../../../component/loader";
import Breadcrumb from "../../../component/breadcrumb";
import ViewRequestorsDialog from "./viewRequestorDialog";
import { withTranslation } from "react-i18next";
import formatDate from "../../../helper/dateFormatter";

class SolutionsContracts extends Component {
  state = {
    title: "",
    description: "",
    parties: {},
    effectiveDate: "",
    expiryDate: "",
    providerList: [],
    loading: false,
    myAllContracts: [],
    inboundContracts: [],
    outboundContracts: [],
    today: "",
    selectedContractId: "",
    selectedContractReceiver: {},
    documentDescription: "",
    documentName: "",
    docEffectiveDate: "",
    docExpiryDate: "",
    openAddContract: false,
    solutionContracts: [],

    //used to add table data
    tableCell: [],

    //prepare contracts
    contracts: [],

    //to get party to ids
    contractForPartyList: [],

    //dialog box
    open: false,
    //pdf dialog
    pdfView: false,

    //pdf doc base64
    base64PdfDocument: "",

    salesChannelProvidersList: [],
    solutionProvidersList: [],
    serviceProvidersList: [],
    searching: true,
    bread: [],

    contractSortBy: "title",
    contractSortOrder: "ASC",

    requestorsListContractId: "",
    showRequestorsDialog: false,
    requestorListPartyId: "",
  };

  componentDidMount() {
    this.getIntialData();
    let bread = [
      {
        title: localStorage.getItem("selectedAvailableSolutionProvider"),
        url: `/availableOfferings`,
      },
      {
        title: this.props.t("CONTRACTS"),
        url: `/${this.props.router.params.provider}/contracts`,
      },
    ];
    this.setState({ bread });
  }

  getIntialData = () => {
    this.setState({
      loading: true,
    });
    BusApiCall(
      "GET",
      `${constants.busV4Url}/providers/${this.props.router.params.provider}/contracts`,
    )
      .then((res) => {
        let myAllContracts = res.data.contracts.outboundContracts;
        let solutionContracts = [];
        for (var i = 0; i < myAllContracts.length; i++) {
          if (
            myAllContracts[i].parties.from.id ===
            this.props.router.params.provider
          ) {
            if (myAllContracts[i].status === "Published") {
              if (!myAllContracts[i].parties.to.id) {
                if (
                  myAllContracts[i].parties.to.type === this.props.providerType
                ) {
                  solutionContracts.push(myAllContracts[i]);
                }
              }
            }
          }
        }
        solutionContracts.sort((a, b) => {
          if (this.state.contractSortOrder === "ASC") {
            if (this.state.contractSortBy === "providerType") {
              let type = "type";
              if (a.parties.to[type] < b.parties.to[type]) {
                return -1;
              }
              if (a.parties.to[type] > b.parties.to[type]) {
                return 1;
              }
              return 0;
            } else {
              if (a[this.state.contractSortBy] < b[this.state.contractSortBy]) {
                return -1;
              }
              if (a[this.state.contractSortBy] > b[this.state.contractSortBy]) {
                return 1;
              }
              return 0;
            }
          } else {
            if (this.state.contractSortBy === "providerType") {
              let type = "type";
              if (a.parties.to[type] > b.parties.to[type]) {
                return -1;
              }
              if (a.parties.to[type] < b.parties.to[type]) {
                return 1;
              }
              return 0;
            } else {
              if (a[this.state.contractSortBy] > b[this.state.contractSortBy]) {
                return -1;
              }
              if (a[this.state.contractSortBy] < b[this.state.contractSortBy]) {
                return 1;
              }
              return 0;
            }
          }
        });
        this.setState({
          myAllContracts: myAllContracts,
          solutionContracts: solutionContracts,
          loading: false,
          searching: false,
        });
      })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.message) {
          this.props.setErrorMessage(err.response.data.message, false);
        } else {
          this.props.setErrorMessage(
            this.props.t("DEFAULT_ERROR_MESSAGE"),
            false,
          );
        }
        this.setState({ loading: false });
      });
  };

  requestContract = (contractData) => {
    this.setState({
      loading: true,
    });
    let providerType = "";
    if (this.props.providerType === "SALES_CHNL_PROVIDER") {
      providerType = "/sales-channel-providers";
    } else if (this.props.providerType === "SOLUTION_PROVIDER") {
      providerType = "/solution-providers";
    } else if (this.props.providerType === "SERVICE_PROVIDER") {
      providerType = "/service-providers";
    }
    let requestData = {};
    BusApiCall("GET", `${constants.busV4Url}${providerType}`)
      .then((res) => {
        let providersList = res.data;
        let provider = providersList.find(
          (obj) => this.props.tenantId === obj.id,
        );
        requestData.requestorName = provider.contacts[0].name;
        requestData.requestorEmail = provider.contacts[0].email;
        requestData.requestorPhone = provider.contacts[0].phone;
        requestData.requestorOrg = provider.name;
        requestData.contractName = contractData.title;
        requestData.senderPartyId = this.props.tenantId;
        let recipientType = "";
        if (contractData.parties.from.type === "SALES_CHNL_PROVIDER") {
          recipientType = "/sales-channel-providers";
        } else if (contractData.parties.from.type === "SOLUTION_PROVIDER") {
          recipientType = "/solution-providers";
        } else if (contractData.parties.from.type === "SERVICE_PROVIDER") {
          recipientType = "/service-providers";
        }
        BusApiCall("GET", `${constants.busV4Url}${recipientType}`)
          .then((response) => {
            let recipientsList = response.data;
            let recipient = recipientsList.find(
              (obj) => contractData.parties.from.id === obj.id,
            );
            if (!recipient) {
              recipient = recipientsList.find(
                (obj) => contractData.parties.from.id === obj.externalId,
              );
            }
            requestData.recipientName = recipient.contacts[0].name;
            requestData.contractOwnerEmail = recipient.contacts[0].email;
            requestData.receiverPartyId = recipient.id;

            BusApiCall(
              "POST",
              `${constants.busV4Url}/providers/${requestData.receiverPartyId}/contracts/${contractData.id}/requests`,
              requestData,
            )
              .then((mailResponse) => {
                this.props.setErrorMessage(
                  this.props.t("Provider notified of contract request"),
                  true,
                );
                this.setState({
                  loading: false,
                });
              })
              .catch((err) => {
                if (
                  err.response &&
                  err.response.data &&
                  err.response.data.message
                ) {
                  this.props.setErrorMessage(err.response.data.message, false);
                } else {
                  this.props.setErrorMessage(
                    this.props.t("DEFAULT_ERROR_MESSAGE"),
                    false,
                  );
                }
                this.setState({
                  loading: false,
                });
              });
          })
          .catch((err) => {
            if (
              err.response &&
              err.response.data &&
              err.response.data.message
            ) {
              this.props.setErrorMessage(err.response.data.message, false);
            } else {
              this.props.setErrorMessage(
                this.props.t("DEFAULT_ERROR_MESSAGE"),
                false,
              );
            }
            this.setState({
              loading: false,
            });
          });
      })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.message) {
          this.props.setErrorMessage(err.response.data.message, false);
        } else {
          this.props.setErrorMessage(
            this.props.t("DEFAULT_ERROR_MESSAGE"),
            false,
          );
        }
        this.setState({
          loading: false,
        });
      });
  };

  updateContractSorting = (sortBy) => {
    if (sortBy === this.state.contractSortBy) {
      let contractSortOrder =
        this.state.contractSortOrder === "ASC" ? "DESC" : "ASC";
      this.setState({
        contractSortOrder:
          this.state.contractSortOrder === "ASC" ? "DESC" : "ASC",
      });
      let data = this.state.solutionContracts;
      data.sort((a, b) => {
        if (contractSortOrder === "ASC") {
          if (this.state.contractSortBy === "providerType") {
            let type = "type";
            if (a.parties.to[type] < b.parties.to[type]) {
              return -1;
            }
            if (a.parties.to[type] > b.parties.to[type]) {
              return 1;
            }
            return 0;
          } else {
            if (a[this.state.contractSortBy] < b[this.state.contractSortBy]) {
              return -1;
            }
            if (a[this.state.contractSortBy] > b[this.state.contractSortBy]) {
              return 1;
            }
            return 0;
          }
        } else {
          if (this.state.contractSortBy === "providerType") {
            let type = "type";
            if (a.parties.to[type] > b.parties.to[type]) {
              return -1;
            }
            if (a.parties.to[type] < b.parties.to[type]) {
              return 1;
            }
            return 0;
          } else {
            if (a[this.state.contractSortBy] > b[this.state.contractSortBy]) {
              return -1;
            }
            if (a[this.state.contractSortBy] < b[this.state.contractSortBy]) {
              return 1;
            }
            return 0;
          }
        }
      });
      this.setState({ solutionContracts: data });
    } else {
      this.setState({
        contractSortOrder: "ASC",
        contractSortBy: sortBy,
      });
      let data = this.state.solutionContracts;
      data.sort((a, b) => {
        if (sortBy === "providerType") {
          let type = "type";
          if (a.parties.to[type] < b.parties.to[type]) {
            return -1;
          }
          if (a.parties.to[type] > b.parties.to[type]) {
            return 1;
          }
          return 0;
        } else {
          if (a[sortBy] < b[sortBy]) {
            return -1;
          }
          if (a[sortBy] > b[sortBy]) {
            return 1;
          }
          return 0;
        }
      });
      this.setState({ solutionContracts: data });
    }
  };

  viewRequestors = (id, party, title) => {
    this.setState({
      requestorsListContractId: id,
      requestorListPartyId: party,
      requestedContractId: title,
      showRequestorsDialog: true,
    });
  };

  closeRequestorDialog = () => {
    this.setState({
      requestorsListContractId: "",
      requestorListPartyId: "",
      requestedContractId: "",
      showRequestorsDialog: false,
    });
  };

  render() {
    return (
      <div className={"newContentWrapper"}>
        <div className={"breadcrumbWrapper"}>
          <div className={"breadcrumbContent"}>
            <Grid container>
              <Grid
                item
                size={{
                  xs: 12,
                }}
              >
                <Breadcrumb list={this.state.bread} />
              </Grid>
            </Grid>
          </div>
        </div>
        <main>
          <Grid container spacing={3} style={{ marginTop: 0 }}>
            <Grid
              item
              size={{
                xs: 12,
              }}
            >
              {/* Dynamic Table */}
              <ProviderTable
                formatDate={formatDate}
                solutionContracts={this.state.solutionContracts}
                searching={this.state.searching}
                requestContract={this.requestContract}
                selectedProviderId={this.props.router.params.provider}
                contractSortBy={this.state.contractSortBy}
                contractSortOrder={this.state.contractSortOrder}
                updateContractSorting={this.updateContractSorting}
                viewRequestors={this.viewRequestors}
              />
            </Grid>
          </Grid>
          {/* View contractors list dialog */}
          {this.state.showRequestorsDialog && (
            <ViewRequestorsDialog
              open={this.state.showRequestorsDialog}
              contractId={this.state.requestorsListContractId}
              requestorListPartyId={this.state.requestorListPartyId}
              contractTitle={this.state.requestedContractId}
              close={this.closeRequestorDialog}
            />
          )}
          <Loader loading={this.state.loading} />
        </main>
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    providerType: state.auth.providerType,
    tenantId: state.auth.tenantId,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setErrorMessage: (errMsg, msgType) =>
      dispatch({ type: actionTypes.SET_ERROR_MSG, errMsg, msgType }),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation("translations")(SolutionsContracts));
